module.exports = {
  VERSION: require('../package.json').version,
  createDashboard: require('./api/create-dashboard')
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/index.js
// module id = 342
// module chunks = 2 3